import DiscussMariaAbout from "components/About/DiscussMariaAbout";
import SocialMedia from "components/About/SocialMedia";
import Address from "components/Contact/Address";
import ContactFormPage from "components/Contact/ContactFormPage";
import ContactForm from "components/Contact/FormContact";
import FullContactForm from "components/Contact/FullContactForm";
import HeroContact from "components/Contact/HeroContact";
import TwoContactPath from "components/Contact/TwoContactPath";
import LatestWorkshop from "components/Homepage/LatestWorkshop";
import React from "react";

const Contact = () => {
  return (
    <div className="w-full max-w-7xl mx-auto rounded-xl my-8 overflow-hidden">
      {" "}
      {/* <HeroContact /> */}
      {/* <TwoContactPath /> */}
      {/* <ContactForm /> */}
      <FullContactForm />
      {/* <Address /> */}
      {/* <DiscussMariaAbout /> */}
      {/* <SocialMedia /> */}
    </div>
  );
};

export default Contact;
